// @flow

/**
 * Client handling the authentification
 */
import constants from './constants';
// @TODO hack for RN, shall we use a polyfill ?
const _fetch = typeof fetch === 'function' && fetch || require('isomorphic-fetch');

function getQueries(query: Object): string {
  if (!query) {
    return '';
  }

  const str: string = Object.entries(query)
    .filter(([key, value]) => value !== undefined)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map(x => `${key}=${x}`).join('&');
      }
      return `${key}=${value}`;
    })
    .join('&');
  return !!str ? encodeURI('?' + str) : '';
}

type requestOptions = { query?: Object, headers?: Object };
function constructRequest(apiPath: string, path: string, reqOptions: requestOptions = {}): Object {
  const { query = {}, headers = {}, ...options } = reqOptions;

  const completeURL = apiPath + path + getQueries(query);
  const completeHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  return {
    completeURL,
    options: { ...options, headers: completeHeaders, credentials: 'include' },
  };
}


async function api(path: string, reqOptions: requestOptions = {}): Object {
  const request = constructRequest(constants.API_PATH, path, reqOptions);

  const response = await _fetch(request.completeURL, request.options);
  const responseJSON = await response.json();

  if (responseJSON.status && !responseJSON.status.success) {
    throw responseJSON;
  }

  return responseJSON;
}

async function apiSolaris(path: string, reqOptions: requestOptions = {}): Object {
  const request = constructRequest(constants.SOLARIS_API_PATH, path, reqOptions);

  const response = await _fetch(request.completeURL, request.options);
  const responseJSON = await response.json();

  return responseJSON;
}

export { api as fetch, apiSolaris as fetchSolaris };



// WEBPACK FOOTER //
// ./~/virgo/src/api.js